<template>
	<section class="section section--documents">
		<div class="container">
			<app-heading title="Documents" tag="h2" />
			<app-documents />
		</div>
	</section>
</template>

<script>
	import Documents from '@/pages/documents/documents.vue'
	import Heading from '@/components/heading/heading.vue'
	
	export default {
		components: {
			appDocuments: Documents,
			appHeading: Heading
		}
	}
</script>
